exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".comment-history-title[data-v-23e6a226] {\n}\n", ""]);

// exports
